import React from "react";
import { useState } from "react";
import { useEditor } from "../../EditorContext";


function SubformEnum({control, formStructure}){

  const { updateFieldUiSchema, updateFieldSchema, updateFieldData } = useEditor()
  const [options, setOptions] = useState(['', ''])

  console.log(control)
  //alert(1)

  React.useEffect(() => {
    setOptions(control.schemaProps.enum)
  }, []);
  

  function UpdateOption (index, value) {
    let newOptions = structuredClone(options)
    newOptions[index] = value
    setOptions(newOptions)
    
    let inputObject = {
      id: "enum",
      value: newOptions
    }
    //console.log(inputObject)

    updateFieldSchema(formStructure, control.id, inputObject)
  }

  function AddOption (options) {
    let newOptions = structuredClone(options)
    newOptions.push('')
    setOptions(newOptions)
  }

  function RemoveOption (options, index) {
    let newOptions = structuredClone(options)
    newOptions.splice(index, 1)
    setOptions(newOptions)
  }

  let rows = []
  for (let i in options) {
    rows.push(
      <div 
        className="row mb-3" 
        key={control.id + '_option_' + i}
      >
        <div className="col-sm-4">
          <input
            id={i}
            type="text"
            className="form-control"
            value={options[i]}
            onChange={(e) => UpdateOption(i, e.target.value)}
            placeholder=""
          />
        </div>
        <div className="col-sm-1">
          { options.length > 2 ? 
            <button onClick={(e) => RemoveOption(options, i)}>Х</button>
          :
            <></>
          }
        </div>  
      </div>  
    )
  }

  return(
    <div className="form m-3">
      <label className="label mb-3">Варианты ответа:</label>
        {rows}
        { options.length < 10 ? 
          <button onClick={() => AddOption(options)}>+</button>
        :
          <></>
        }  
    </div>
  )
}

export default SubformEnum